export enum DownloadHistoryStatusE {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
  IN_PROGRESS = 'IN_PROGRESS',
}
